import { Component, Input, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';

@Component({
  selector: 'custom-step',
  standalone: true,
  template: `
    <ng-template #stepContent>
      <ng-content></ng-content>
    </ng-template>
  `
})
export class CustomStepComponent implements AfterViewInit {
  @Input() label: string = '';
  @Input() stepId?: string;
  @Input() completed: boolean = false;
  @Input() optional: boolean = false;
  @Input() disabled: boolean = false;
  @Input() hasError: boolean = false;
  @Input() editable: boolean = true;
  @Input() hidden: boolean = false;
  
  @ViewChild('stepContent', { static: true }) content!: TemplateRef<any>;
  
  // Internal properties
  _stepIndex: number = 0;
  _isActive: boolean = false;
  _isVisited: boolean = false;
  
  ngAfterViewInit(): void {
    // Content is ready after view init
  }
  
  get stepIndex(): number {
    return this._stepIndex;
  }
  
  get isActive(): boolean {
    return this._isActive;
  }
  
  get isVisited(): boolean {
    return this._isVisited;
  }
  
  markAsVisited(): void {
    this._isVisited = true;
  }
  
  reset(): void {
    this._isVisited = false;
    this._isActive = false;
  }
}
